import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";

export const useGetAllClaimDashboardService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [claimDashboardSearchQuery, setClaimDashboardSearchQuery] =
    useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(
    claimDashboardSearchQuery
  );

  const allClaimDashboardService = useQuery({
    queryKey: [...CACHE_KEYS.CLAIM_DASHBOARD, page, per_page, debouncedQuery],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS.CLAIM_DASHBOARD,
        searchParams: {
          page,
          per_page,
        },
      });
    },
    enabled: enableQuery,
  });
  return {
    service: { allClaimDashboardService },
    states: { claimDashboardSearchQuery, setClaimDashboardSearchQuery },
  };
};
